import posed from 'react-pose'

const FadeAndExpand = posed.div({
  enter: {
    opacity: 1,
    height: 'auto',
    // delay: 1000,
    // staggerChildren: 100,
    width: '100%'
  },
  exit: {
    height: 0,
    opacity: 0,
    // staggerChildren: 100
  }
})

export default FadeAndExpand
